import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormSpacer', null, { withChildren: true });
